import SyllabusVM from './syllabus-vm';

export default {
  init: function(node) {
    var course_data = JSON.parse(node.dataset.courseData);
    ko.applyBindings(new SyllabusVM(course_data), node);

    // bind enroll modal events
    $('#js-course-enroll-modal--options').on('shown.bs.modal', function(){
      $('#js-course-enroll-modal--options').find('input')[0].focus();
    });
    $('#js-course-enroll-modal--options').on('hidden.bs.modal', function(){
      $('.js-enroll-btn').focus();
    });
  }
};
